import { Pipe, PipeTransform } from '@angular/core';
import { CountryService } from '../services/countries-service';
import { catchError, from, map, Observable, of } from 'rxjs';

@Pipe({
    name: 'CountryTransformPipe',
    standalone: false
})
export class CountryTransformPipe implements PipeTransform {

  constructor(private countryService: CountryService) { }

  transform(countryCode: string | null | undefined): Observable<string | undefined> {
    if (!countryCode || typeof countryCode !== 'string') {
      console.warn('Invalid or undefined country code:', countryCode);
      return of(undefined);
    }

    const code = countryCode.trim().toUpperCase();

    return from(this.countryService.getCountries()).pipe(
      map((countries) => {
        const match = countries.find((c) => (c.alpha2 ?? '').toUpperCase() === code);
        if (!match) {
          console.warn('Unknown country code:', countryCode);
        }
        return match?.name;
      }),
      catchError(() => of(undefined))
    );
  }
}
